import { render, staticRenderFns } from "./LedianForgotPassword.vue?vue&type=template&id=0c1cbaf8&scoped=true&"
import script from "./LedianForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./LedianForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./LedianForgotPassword.vue?vue&type=style&index=0&id=0c1cbaf8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1cbaf8",
  null
  
)

export default component.exports